import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from '../ui';
import authActions from '../../ducks/auth/actions';
import AcceptTermsWrapper from './AcceptTerms.style';

const AcceptTermsComponent = () => {

  const { isLoading, user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const handleLoggoutOnClose = () => dispatch(authActions.logout());
  const handleAcceptTerms = () => dispatch(authActions.acceptTermsRequest({ userCode: user.userCode }));
  
  return (
    <Modal title="DECLARACION DE PROVEEDOR" dataTestId="testTitle" close={handleLoggoutOnClose} show>
      <AcceptTermsWrapper>
        <p>
          Mediante la firma del presente documento DECLARO: Que fui informado de que es un requisito para hacer negocios
          con Seguros SURA S.A. conocer y respetar el Código de Conducta, el Código de Conducta para Proveedores y la
          Política de Regalos y Atenciones de SURA, documentos que declaro conocer y saber que se encuentran disponibles
          en &nbsp;
          <a
            href="http://www.segurossura.com.uy/media/Codigo-de-Conducta-Grupo-Empresarial-SURA.pdf"
            rel="noopener noreferrer"
            target="_blank"
          >
            http://www.segurossura.com.uy/media/Codigo-de-Conducta-Grupo-Empresarial-SURA.pdf
          </a>
          , &nbsp;
          <a
            href="http://www.segurossura.com.uy/media/Codigo-de-Conducta-Proveedores.pdf"
            rel="noopener noreferrer"
            target="_blank"
          >
            http://www.segurossura.com.uy/media/Codigo-de-Conducta-Proveedores.pdf
          </a>
          &nbsp; y &nbsp;
          <a
            href="https://www.segurossura.com.uy/media/Poli%CC%81tica-de-regalos-y-atenciones.pdf"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://www.segurossura.com.uy/media/Política-de-regalos-y-atenciones.pdf
          </a>
          . &nbsp; Que como Proveedor me comprometo con los principios establecidos en el Código de Conducta referido y
          sé que, en caso de incumplimiento, Seguros SURA S.A. se reserva el derecho de rescindir el contrato. Que como
          Proveedor asumo el compromiso de revelar a través de la Línea Ética &nbsp;
          <a href="https://www.suramericana.com/lineaetica/index.html" rel="noopener noreferrer" target="_blank">
            https://www.suramericana.com/lineaetica/index.html
          </a>
          &nbsp; las conductas por parte de los empleados, que no sean acordes a los lineamientos establecidos por
          Seguros SURA S.A. en su Código de Conducta Empresarial. Que AUTORIZO a que Seguros SURA S.A. y Suramericana
          S.A. , hagan el tratamiento de mis datos personales para vincularme como Potencial Proveedor. La anterior
          autorización la otorgo con fines estadísticos, comerciales, financieros, en aquellas operaciones que directa o
          indirectamente pudieran surgir en virtud de los servicios que potencialmente pudiese prestar a Seguros SURA
          S.A. y/o Suramericana S.A. sus filiales y/o subsidiarias diferentes a la de Uruguay. Además de las finalidades
          contenidas en su política de privacidad, la cual puede ser consultada en &nbsp;
          <a
            href="https://www.segurossura.com.co/Paginas/legal/politica-privacidad-datos.aspx"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://www.segurossura.com.co/Paginas/legal/politica-privacidad-datos.aspx
          </a>
          . &nbsp; Que conozco y entiendo que Seguros SURA S.A., Suramericana S.A, sus filiales y/o subsidiarias, no
          asumen responsabilidad alguna por los daños y perjuicios de toda naturaleza que pudieran derivarse por la
          falta de veracidad, exhaustividad y/o autenticidad de la información que como Proveedor proporciono en el
          registro. Será este último el único responsable por los daños y perjuicios de toda naturaleza que pudiera
          sufrir Suramericana S.A, filiales y/o subsidiarias, directa o indirectamente, como consecuencia de la
          idoneidad, calidad y veracidad de los datos entregados.
        </p>
        <div className="buttonsBar">
          <Button plain onClick={handleLoggoutOnClose} style={{ marginRight: 10 }}>
            <span style={{ fontWeight: 500, fontSize: 23 }}>Cerrar</span>
          </Button>

          <Button onClick={handleAcceptTerms} isLoading={isLoading}>
            <span style={{ fontSize: 17 }}>Acepto los terminos y condiciones</span>
          </Button>
        </div>
      </AcceptTermsWrapper>
    </Modal>
  );
};

export default AcceptTermsComponent;
